<script setup>
import { computed } from 'vue';
import CourseAlphaSection from '@/js/core/components/parts/courses/CourseAlphaSection.vue';

const props = defineProps({
  courses: {
    type: Array,
    required: true,
    default: () => [],
  },
  hasMore: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['load-more']);

// The server orders by title; pages append in order, so no client re-sort.
const groupedCourses = computed(() => {
  const groups = {};

  props.courses.forEach(course => {
    const firstLetter = course.name.charAt(0).toUpperCase();
    if (!groups[firstLetter]) {
      groups[firstLetter] = [];
    }
    groups[firstLetter].push(course);
  });

  return Object.keys(groups)
    .sort()
    .map(letter => ({
      letter,
      items: groups[letter],
    }));
});
</script>

<template>
  <div class="courses-view-alphabetical">
    <div v-if="groupedCourses.length === 0" class="no-results">
      There are no results for selected filters.
    </div>

    <table v-else class="courses-alphabetical-table">
      <CourseAlphaSection
        v-for="group in groupedCourses"
        :key="group.letter"
        :letter="group.letter"
        :courses="group.items"
      />

      <tbody v-if="hasMore" class="courses-section-item__load-more">
        <tr>
          <td colspan="3">
            <div>
              <a href="#" class="load-more-btn" @click.prevent="$emit('load-more')"> Next page </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped></style>
